import { usePageAttributes } from '@/components/contexts/PageAttributesContext';
import { seoSegmentationListingPage_seoSegmentationStats_SEOSegmentationStatsSuccess_caregiverStats as SEOSegmentationCaregiverStats } from '@/__generated__/seoSegmentationListingPage';

interface ProductSchemaProps {
  avgReviewRating: NonNullable<SEOSegmentationCaregiverStats['avgReviewRating']>;
  totalReviewCount: NonNullable<SEOSegmentationCaregiverStats['totalReviewCount']>;
}

interface Product {
  '@context': string;
  '@type': string;
  name: string;
  brand: {
    '@type': string;
    name: string;
  };
  aggregateRating?: {
    '@type': string;
    ratingValue: string;
    reviewCount: string;
    bestRating: string;
    worstRating: string;
  };
}

export const ProductSchema = ({ avgReviewRating, totalReviewCount }: ProductSchemaProps) => {
  const { segmentNamePluralLowerCase } = usePageAttributes();

  const nameTitle =
    segmentNamePluralLowerCase.charAt(0).toUpperCase() + segmentNamePluralLowerCase.slice(1);

  const ProductSchemaList = () => {
    const roundAvgReviewRating = avgReviewRating.toFixed(1);

    const product: Product = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: nameTitle,
      brand: {
        '@type': 'Organization',
        name: 'Care.com',
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: roundAvgReviewRating,
        reviewCount: `${totalReviewCount}`,
        bestRating: '5',
        worstRating: '1',
      },
    };

    return product;
  };

  return (
    <script
      data-testid="productSchema"
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(ProductSchemaList()) }}
    />
  );
};
